import { useTranslation } from 'react-i18next'
import { Box, Button, Divider } from '@mui/material'

type Props = {
  disableActions: boolean
  handleOnSave: () => void
  handleOnCancel: () => void
}

const ActionsProfileDetails = ({
  disableActions,
  handleOnSave,
  handleOnCancel,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Box mt={2}>
      <Divider light />
      <Box mt={2} display="flex" justifyContent="end">
        <Button
          onClick={handleOnCancel}
          className="red"
          size="small"
          variant="contained"
        >
          {t('labels.cancel')}
        </Button>
        <Button
          sx={{ marginLeft: 2 }}
          disabled={disableActions}
          onClick={handleOnSave}
          color="primary"
          size="small"
          variant="contained"
        >
          {t('labels.save')}
        </Button>
      </Box>
    </Box>
  )
}

export default ActionsProfileDetails
